import {SpImage} from "./DataModels";

export const getLoadedImage = (imageUrl: string) => {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageUrl;
        img.onload = () => resolve(img);
        img.onerror = reject;
    });
}

export const getNearSizeImage = (images: SpImage[], width: number) => {
    let nearSizeImage = images[0];
    images.forEach(image => {
        if (image.width > width && image.width < nearSizeImage.width) {
            nearSizeImage = image;
        }
    });
    return nearSizeImage;
}

export const createPixelatedImage = async (imageUrl: string, originalSize: [number, number], upScaledSize: [number, number]) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const originalWidth = originalSize[0];
    const originalHeight = originalSize[1];
    const canvasWidth = upScaledSize[0];
    const canvasHeight = upScaledSize[1];
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    const img = await getLoadedImage(imageUrl);

    ctx!.imageSmoothingEnabled = false;
    ctx!.drawImage(img, 0, 0, canvasWidth, canvasHeight);
    return canvas.toDataURL();
}